module.exports = __webpack_public_path__ + "img/to.07086162.svg";